module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-component"
  }, [((!_vm.$breakpoints.xs)) ? _c('div', [_c('div', {
    staticClass: "ticket-title"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h3', [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-performance-info-main', {
    attrs: {
      "order": _vm.order,
      "active-order": true,
      "cinema": _vm.cinema
    },
    on: {
      "closeDialog": function($event) {
        _vm.ticketMobile = false;
        _vm.loading = true
      }
    }
  }), _vm._v(" "), _vm._l((_vm.order.Sessions), function(session, index) {
    return (_vm.order.Sessions && session.SessionId !== _vm.order.Session.SessionId) ? _c('sk-performance-info', {
      key: index,
      attrs: {
        "order": _vm.order,
        "index": index,
        "session": session,
        "cinema": _vm.cinema
      },
      on: {
        "closeDialog": function($event) {
          _vm.ticketMobile = false;
          _vm.loading = true
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    staticClass: "ticket-component-content--heading",
    attrs: {
      "h6": "",
      "label": "Your Extras as"
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.isConcessionStep) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "router": "",
      "to": "/booking/2"
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('sk-list', _vm._l((_vm.order.Concessions), function(concession, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('sk-ticket-seats', {
      attrs: {
        "add-quantity": true,
        "ticket-obj": concession,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "fullscreen": true,
      "overlay": false
    },
    model: {
      value: (_vm.ticketMobile),
      callback: function($$v) {
        _vm.ticketMobile = $$v
      },
      expression: "ticketMobile"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.ticketMobile = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-performance-info-main', {
    attrs: {
      "order": _vm.order,
      "active-order": true,
      "cinema": _vm.cinema
    },
    on: {
      "closeDialog": function($event) {
        _vm.ticketMobile = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.order.Sessions), function(session, index) {
    return (_vm.order.Sessions && session.SessionId !== _vm.order.Session.SessionId) ? _c('sk-performance-info', {
      key: index,
      attrs: {
        "session": session,
        "order": _vm.order,
        "index": index,
        "cinema": _vm.cinema
      },
      on: {
        "closeDialog": function($event) {
          _vm.ticketMobile = false
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    staticClass: "ticket-component-content--heading",
    attrs: {
      "h6": "",
      "label": "Your Extras as"
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.isConcessionStep) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "router": "",
      "to": "/booking/2"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.ticketMobile = false
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('sk-list', _vm._l((_vm.order.Concessions), function(concession, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": concession,
        "add-quantity": true,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Are you sure you want to cancel your booking?")]), _vm._v(" "), _c('p', [_vm._v("By clicking cancel you'll lose your seats and might not get them back again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder();
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("I'm sure\n            ")])]], 2), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.order.toggleMaxAmountPurchaseDialog),
      callback: function($$v) {
        _vm.$set(_vm.order, "toggleMaxAmountPurchaseDialog", $$v)
      },
      expression: "order.toggleMaxAmountPurchaseDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Maximum Booking Total")]), _vm._v(" "), _c('p', [_vm._v("This item could not be added to the order because the maximum booking total of " + _vm._s(_vm.currency) + _vm._s(_vm.maxTotal) + " has been exceeded.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.order.toggleMaxAmountPurchaseDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialog($event)
      }
    }
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    staticClass: "text-left visible-xs",
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-icon', {
    attrs: {
      "arrow-up": ""
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('span', [_vm._v("Total")]), _vm._v(" " + _vm._s(_vm.orderTotal) + "\n                ")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4550e006","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/ticket/ticket.vue
// module id = 754
// module chunks = 0